import LatestTitleIssues from "@Pages/LatestTickets/LatestTickets";

import Select from "@Components/Select";
import useCurrentUser from "@Hooks/useCurrentUser";
import DealersDashboard from "@Pages/DealersDashboard";
import {
  hasActionPermissions,
  hasSectionPermissions,
} from "@Utils/permissions";
import { useState } from "react";
import styles from "./Dashboard.module.scss";

const DashboardSwitch = ({
  dashboard,
  select,
}: {
  dashboard: string;
  select: JSX.Element | null;
}) => {
  switch (dashboard) {
    case "dealers":
      return <DealersDashboard dashboardSelect={select} />;
    case "titleIssues":
      return <LatestTitleIssues dashboardSelect={select} />;
    default:
      return <div></div>;
  }
};

const Dashboard = () => {
  const user = useCurrentUser();
  let defaultDashboard = "";
  const hasAccessToFinance = hasSectionPermissions("deal", "financials", user);
  const hasAccessToLenderTickets = hasActionPermissions(
    "lender_ticket",
    "read",
    user
  );
  if (hasAccessToFinance) {
    defaultDashboard = "dealers";
  } else if (hasActionPermissions("lender_ticket", "read", user)) {
    defaultDashboard = "titleIssues";
  }

  const [currentDashboard, setCurrentDashboard] = useState(defaultDashboard);

  const dashboardSelect =
    hasAccessToFinance && hasAccessToLenderTickets ? (
      <Select
        required
        placeholder="Dashboard"
        name="Dashboard"
        id="dashboard"
        onChange={(e) => setCurrentDashboard(e.target.value)}
        value={currentDashboard}
        options={[
          {
            label: "Dealers Dashboard",
            value: "dealers",
          },
          {
            label: "Title Issues Dashboard",
            value: "titleIssues",
          },
        ]}
      />
    ) : null;
  return (
    <div className={styles.root}>
      <div className={styles.dashboardContainer}>
        <DashboardSwitch
          dashboard={currentDashboard}
          select={dashboardSelect}
        />
      </div>
    </div>
  );
};
export default Dashboard;
